<!--
 * @Author: your name
 * @Date: 2021-07-09 13:47:07
 * @LastEditTime: 2021-07-14 14:54:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /pbr/src/components/pbr/index/charts/business/business.vue
-->
<template>
  <el-row v-if="single">
    <el-col :md="8" :xs="24">
      <business-type :height="height"
                     ref="type"
                     :show-title="true"></business-type>
    </el-col>
    <el-col :md="8" :xs="24">
      <business-country :height="height"
                        ref="nation"
                        :show-title="true"></business-country>
    </el-col>
    <el-col :md="8" :xs="24">
      <business-line :height="height"  ref="line" :show-title="true"></business-line>
    </el-col>
  </el-row>

</template>

<script>

import BusinessCountry from './business_contry.vue'
import BusinessType from './business_type.vue'
import BusinessLine from './business_line.vue'

export default {
  name: 'pbrChartBusinessIndex',
  props: {
    single: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      height: 200
    }
  },
  components: {
    BusinessCountry,
    BusinessType,
    BusinessLine
  },
  methods: {
    businessCountryChartClick (name) {
      // this.$emit('business-country-chart-click', name)
      // this.$emit('update:emphasesCategory', 'business')
    },
    businessTypeChartClick (name) {
      // this.$emit('business-country-chart-click', name)
      // this.$emit('update:emphasesCategory', 'business')
    },
    businessTrendChartClick (name) {
      // this.$emit('business-country-chart-click', name)
      // this.$emit('update:emphasesCategory', 'business')
    },
    resize () {
      this.$refs.line && this.$refs.line.resize()
      this.$refs.nation && this.$refs.nation.resize()
      this.$refs.type && this.$refs.type.resize()
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize)
    let bodyStyle = window.getComputedStyle(document.body)
    let computedStyle = window.getComputedStyle(document.querySelector('.pbr-index-charts'))

    this.height = Math.min(parseFloat(computedStyle.height), parseFloat(computedStyle.width))
    if (parseInt(bodyStyle.height) < 992) {
      this.height = parseFloat(computedStyle.height) / 3 - 20
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
